import React, { Component } from "react";

// Deliberately dependency-free (no Redux, no locale, no Header/Footer):
// this is the fallback for when something else broke, so it must not be
// able to break itself.
const containerStyle = {
  minHeight: "60vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  padding: "40px 20px",
};

const buttonStyle = {
  marginTop: "16px",
  padding: "10px 24px",
  border: "none",
  borderRadius: "4px",
  background: "#e2001a",
  color: "#fff",
  cursor: "pointer",
  fontSize: "14px",
};

const linkStyle = {
  display: "block",
  marginTop: "12px",
  fontSize: "14px",
};

export default class ErrorBoundary extends Component {

  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div style={containerStyle}>
        <div>
          <p>Sorry, something went wrong. Please reload the page and try again.</p>
          <button style={buttonStyle} onClick={() => window.location.reload()}>Reload</button>
          {this.props.homeHref && (
            <a style={linkStyle} href={this.props.homeHref}>Back to search</a>
          )}
        </div>
      </div>
    );
  }
}
